<template>
  <div class="annual-meeting-product">
    <!-- 产品 -->
     <div class="card-content" v-for="(item,index) in indexMeeting" :key="index">
          <div class="card-content-list" >
            <div class="card-category-img">
              <img :src="item.meetingTypePic?item.meetingTypePic:''" alt="" />
              <div class="card-category-img-hover" >
                <span>20-300人</span>
                <p>说走就走 | 温泉滑雪 | 海岛度假</p>
                <div class="text">祖国这么美一起去走走，世界这么大一起去看看，最重要的是一个团队大家整整齐齐，开开心心。找来一场让大家满意的寻欢之旅，在旅行中感受工作的快乐，体会团队的快乐。</div>
                <div class="more">MORE>></div>
              </div>
            </div>
          <div  v-for="(item,index) in item.meetingList" :key="index">
            <div class="card-content-item1 card-content-item"
              v-on:mouseover="showPicTxt(index)"
              v-on:mouseleave="hidePicTxt()"
              @click="toDetail(2,item.id)">
              <div class="background-pic2" v-bind:style="{backgroundImage:'url(' +'\''+ item.image +'\'' + ')'}"></div>
              <div class="title">{{item.title}}</div>
              <div class="tags"><span>{{item.tagNames}}</span></div>
              <div class="days"><span>{{item.day?item.day:"-"}}天{{item.night?item.night:"-"}}晚 </span>|<span>{{item.numberMin?item.numberMin:"0"}}-{{item.numberMax?item.numberMax:"不限"}}人</span></div>
              <div class="price"><span>¥ {{item.price?item.price:"-"}}</span></div>
              <!-- <div class="product-reason"  v-if="isShowPicTxt == index">
                <p class="product-title">推荐理由</p>
                 <div></div>               
                <p class="product-subtitles">{{item.description}}</p>
                <span class="more">
                  更多
                </span>
              </div> -->
            </div>
          </div>
        </div> 
     </div>  
  </div>
</template>

<script>
import axios from "axios";
import { handlePicPlusPre} from "@/util/util.js";
export default {
  name:"adDetails",
  components: {
    
  },
  props: {},
  data() {
    return {
      id: null,
      message: null,
      indexMeeting:[],
      isShowPicTxt:-1,
    }
     
  },
  watch: {},
  computed: {
    getLocationSiteCityId(){
      return this.$store.state.locationSiteCity;
    },
  },
  methods: {
    // 处理照片路径的方法
    handlePicPlusPre,
    showPicTxt(index) {
      this.isShowPicTxt = index;
    },
    hidePicTxt() {
      this.isShowPicTxt = -1;
    },
    toDetail(type,id){
      // 需要搭建
      if(type==1){
        window.open("/#/annualMeetingConstructDetail?id="+id)  
      }else{
      // 不需要搭建   
       window.open("/#/annualMeetingDetail?id="+id)   
    }
    },
      getMeetingList(){
      const params = {
        cityId:this.getLocationSiteCityId,
        pageNum:1,
        // pageSize:3,
        limitVal:3
      }
      axios
        .get(`/api/meeting/indexList`, {
          params,
        })
        .then((res) => {
          // console.log(200)
          // console.log(res)
          // console.log(res.status)
          if (res.data && res.data.code == 200) {
            console.log(res)
            // this.pageArray = res.data.output.list;
            // this.total = res.data.output.total;
            this.indexMeeting = res.data.indexMeeting;
            this.indexMeeting.forEach(meetingListItem =>{
              if(meetingListItem.meetingTypePic){
                meetingListItem.meetingTypePic = handlePicPlusPre(meetingListItem.meetingTypePic);
                meetingListItem.meetingTypePic = meetingListItem.meetingTypePic[0];
              }
            meetingListItem.meetingList.forEach(element => {
              if(element.tagNames){
              let tagList = element.tagNames.split(" ");
              console.log("tag")
              console.log(tagList)
              let MeetingTag = "";
              tagList.forEach(tag => {
                if(MeetingTag!=""){
                  MeetingTag = MeetingTag + " · " + tag;
                }else{
                  MeetingTag = tag;
                }
              });
              console.log(MeetingTag)
              element.tagNames = MeetingTag;
            if(element.image) {
              element.image = handlePicPlusPre(element.image);
              element.image = element.image[0];
            }
            this.loading = false;
            }
        });
        })
      }
      
      console.log(this.meetingList)
    });
      }

  },
  created() {

  },
  mounted() {
    this.getMeetingList();
  }
};
</script>
<style scoped>
.annual-meeting-product{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;
  height: 100%;
}
.annual-meeting-product .plate-title{
      min-height: 160px;
}
.annual-meeting-product .plate-title span{
    display: inline-block;
    text-align: center;
    width: 100%;
    font-size: 38px;
    color: #201f1f;
    padding-top: 50px;
}
.annual-meeting-product .plate-title p{
    display: inline-block;
    text-align: center;
    width: 100%;
    font-size: 18px;
    color: #666;
    padding-top: 20px;
    padding-bottom: 40px;
}

.annual-meeting-product .card-content {
  width: 1060px;
  /* position:absolute; */
  /* height: 100%; */
  /* display: flex;
  flex-direction: row;
  justify-content: center; */
}
.card-content div .background-pic2 {
  /* width: 100%;
  height: 50%;
  background-size: 100% 100%;
  background-repeat: no-repeat;   */
  /* border-radius: 6px; */
    height: 160px;
    width: 100%;
    background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat;
}
.card-content .product-reason {
  transition: all 0.3s ease-in-out;
  background: #359ff8;
  opacity: 0.9;
  position: absolute;
  left: 0;
  top: 0px;
  width: 100%;
  height: 100%;
  padding: 50px 28px;
  box-sizing: border-box;
  text-align: center;
  border-radius: 6px;
}
.card-content .product-reason span{
 
}
.card-content .product-title {
    font-size: 20px;
    color: #222;
    font-weight: 700;
}

.card-content .product-subtitles {
    font-size: 14px;
    color: #222;
    padding-top: 0px;
}
.card-content .card-content-item{
    height: 380px;
    flex-shrink: 0;
    background: #fff;
    border: 1px solid #f5f5f5;
    height: 338px;
    width: 260px;
    display: block;
    border-radius: 12px;
    transition: all .3s ease-in-out;
    overflow: hidden;
    position: relative;  
}
.card-content .card-content-item:hover{
    cursor: pointer;
    box-shadow: 10px 10px 20px rgb(0 0 0 / 10%); 
}
.card-content .product-reason div{
    transition: all .3s ease-in-out;
    font-size: 14px;
    color: #000;
    border-bottom: 1px solid #000;
    margin: 15px 15px;
    height: 1px;
    text-align: center;
}
.card-content .product-reason span{
    display: block;
    text-align: right;
    font-size: 12px;
    color: #222;
    position: absolute;
    right: 35px;
    bottom: 60px;
}
.card-content-item .title{
    font-weight: 700;
    font-size: 16px;
    color: #222;
    overflow: hidden;
    letter-spacing: 0;
    padding: 13px 18px;
}
.card-content-item .tags{
      padding: 0px 20px;
}
.card-content-item .days{
      padding: 0 18px;
}
.card-content-item .price{
    position: absolute;
    bottom: 14px;
    left: 18px;
}
.card-content-item .tags span{
     height: 20px;
    line-height: 20px;
    display: inline-block;
    font-size: 13px;
    color: #5a5a5a;
    text-align: left;
}
.card-content-item .days span{
    height: 18px;
    line-height: 18px;
    color: #666;
    padding:0px 5px;
    font-size: 13px;
}
.card-content-item .price span{
    font-weight: 700;
    font-size: 18px;
    color: #f9541c;  
}
.card-content-item .price span:after {
    content: " 起";
    color: #222;
    font-size: 14px;
}
.card-category-img img{
    background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat;
    width: 100%;
    height: 100%; 
    position: relative;
    z-index: 3;
}
.card-category-img {
  margin-bottom: 34px;
  transition: all .3s ease-in-out;
  width: 235px;
  height: 338px;
  box-sizing: border-box;
  position: relative;
}
.card-category-img:hover img{
  /* z-index: 1; */
}
.el-row{
  height: 390px;
}
p{
  text-align: left;
}
div{
  text-align: left;
}
.card-content-list{
  flex-direction: row;
    flex-wrap: wrap;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
}

.card-category-img-hover{
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  /* bottom: 20px;
  left: 10px;
  right: 10px; */
  z-index: 2;
  background: #fe4b44;
  border-radius: 12px;
  padding: 20px;
  box-sizing: border-box;
  transition: all .3s ease-in-out;  
}
.card-category-img-hover span{
    position: absolute;
    left: 0;
    top: 30px;
    right: 0;
    text-align: center;
    font-size: 16px;
    color: #ffebbf;
}
.card-category-img-hover p{
    position: absolute;
    left: 0;
    top: 60px;
    right: 0;
    text-align: center;
    font-size: 14px;
    color: #ffebbf;
}
.card-category-img-hover .text{
    position: absolute;
    left: 10px;
    top: 100px;
    right: 10px;
    text-align: center;
    font-size: 14px;
    color: #ffebbf;
    border-top: 1px solid #ffebbf;
    padding-top: 20px;
    margin: 10px 10px 0px 10px;
    text-align: justify;
}
.card-category-img-hover .more{
    position: absolute;
    bottom: 10px;
    right: 10px;
    text-align: center;
    font-size: 14px;
    color: #ffebbf;
    cursor: pointer;
}
.card-category-img-hover{
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/annualMeeting/annualMeetingProduct.vue